export default "__VITE_ASSET__BWLX_efZ__"